import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import {
    decodeResponse200,
    Response200Type,
    openapiWebsiteCmsGetHomePageCarouselRequest,
} from 'src/api_openapi/generated/openapi_website_cms_getHomePageCarousel';
import { CarouselModeType } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';

export type HomePageCarouselModelType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Array<HomePageCarouselModelType> => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

interface ParamsType {
    carousel_type: CarouselModeType;
}

export const getHomePageCarousel = {
    browser: {
        params: (params: ParamsType): ParamsFetchType<ParamsType> => {
            return {
                type: MethodType.GET,
                url: `/api-web/get-home-page-carousel/${params.carousel_type}`,
            };
        },
        decode: decode,
    },
    express: {
        method: MethodType.GET,
        urlBrowser: '/api-web/get-home-page-carousel/:carousel_type',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<ParamsType>): Promise<GenerateUrlApiType> => {
        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                },
            };
        }

        const response = await openapiWebsiteCmsGetHomePageCarouselRequest(
            params.API_URL,
            params.API_TIMEOUT,
            params.jwtToken,
            {
                universe: params.API_UNIVERSE,
                carousel_type: params.req.params.carousel_type,
            }
        );

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body,
        };
    },
};
